export default {
  template: "#vue-store-accordion",
  delimiters: ['${', '}'],
  props: ["store_whitelist"],
  data: function () {
    return {
      stores: [],
      loading: true,
    }
  },
  methods: {
    staticmap_url(store_number) {
      return `${window.fileUrlPrefix}staticmap-${store_number}.png`
    },
    filterStoresResponse(stores) {
      let store_filter = this.store_whitelist ?
          this.store_whitelist.split(/,/g).map(e => parseInt(e.trim())).filter(e => !isNaN(e))
          : null
      let stores_out = []
      for (let store of stores) {
        if (store.distance > 100 && stores_out.length >= 3) {
          break
        } else {
          if (store_filter && !store_filter.includes(store.store_number)) {
            continue
          }
          stores_out.push(store)
        }
      }
      this.stores = stores_out;
      if (this.stores.length > 0) {
        this.$store.commit('setActiveStaticStore', this.stores[0].store_number)
      }
      this.loading = false;
    },
  },
  mounted: function () {
    this.$store.dispatch('getLocation')
    .then(
        success => {
          this.$store.dispatch('getAllStores').then(
              resp => {
                this.filterStoresResponse(this.$store.getters.closest_stores.stores)
              },
              () => {
              }
          )
        },
        () => {
        }
    )
    setTimeout(() => {
      const list = document.getElementById("store-locator-list")
      if (list !== null) {
        list.scrollTo(0, 0)
      }
    }, 25)
  }
}